<template>
  <div id="ticket">
      <div class="ticket_detail_header" slot="header" >
        <h4>{{ $t('supportTickets.newTicketRequest') }}</h4>
      </div>
      <div class="ticket_detail_body">
        <div class="new_subject">
          <div class="label">{{ $t('supportTickets.subject') }}</div>
          <el-input v-model="subject"></el-input>
        </div>
        <div>
          <div class="label">{{ $t('supportTickets.content') }}</div>
          <CommentSection
            ref="commentSection"
            :fileList.sync="uploadFileList"
            :editorData.sync="editorContent"
            :enableCharsLimit="true"
          />
        </div>
      </div>
      <div class="footer_button"  slot="footer">
        <el-button @click="onClose(false)" class="white_button">{{ $t('supportTickets.close') }}</el-button>
        <el-button @click="onSubmit('new')" class="blue_button">{{ $t('supportTickets.createNewTicket') }}</el-button>
      </div>
  </div>

</template>

<script>
import CommentSection from '@/components/support/CommentSection';
import ticketMixin from '@/mixins/ticket';

export default {
  name: 'NewTicket',
  components: { CommentSection },
  mixins: [ticketMixin],
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    ticketDialog:Boolean
  },
  data() {
    return {
      commentList: []
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/components/support/ticket.scss';
</style>
